import { GoogleCloudStorageApiFp } from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export const apiGoogleCloudStorageFp = GoogleCloudStorageApiFp(apiConfig);
export const getAsset = apiGoogleCloudStorageFp.cloudStorageControllerGetImage;

export const QueryKeyGoogleCloudStorage = QueryKey.GoogleCloudStorage;
